import { render, staticRenderFns } from "./eod-button-copy.vue?vue&type=template&id=1056753c"
import script from "./eod-button-copy.vue?vue&type=script&lang=js"
export * from "./eod-button-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports